<button class="button" (click)="tilTiltakBeskrivelse()">
    <p class="label-text">{{ tiltak().tittel }}</p>
    <hb-icon class="label-icon" [iconId]="'arrow-right-1'" />
</button>
